import React from 'react';

const Services = () => {
    const services = [
        {
            icon: 'fas fa-home',
            title: 'Property Sales',
            description: 'Expert assistance in buying and selling residential and commercial properties.'
        },
        {
            icon: 'fas fa-key',
            title: 'Property Rentals',
            description: 'Find the perfect rental property or list your property for rent with us.'
        },
        {
            icon: 'fas fa-chart-line',
            title: 'Investment Consulting',
            description: 'Strategic investment advice to maximize your real estate portfolio returns.'
        },
        {
            icon: 'fas fa-cogs',
            title: 'Property Management',
            description: 'Complete property management services for landlords and property owners.'
        },
        {
            icon: 'fas fa-file-contract',
            title: 'Legal Support',
            description: 'Professional legal assistance for all property transactions and documentation.'
        },
        {
            icon: 'fas fa-search-dollar',
            title: 'Property Valuation',
            description: 'Accurate property valuations for sales, purchases, and investment decisions.'
        }
    ];

    return (
        <section id="services" className="services">
            <div className="container">
                <div className="section-header">
                    <h2>Our Services</h2>
                    <p>Comprehensive real estate solutions for all your needs</p>
                </div>
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <div className="service-icon">
                                <i className={service.icon}></i>
                            </div>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
